const DEFAULT_ANALYTICS_PREFERENCE = true
const DEFAULT_MARKETING_PREFERENCE = false

export type CookieCategories = {
  analytics: boolean
  marketing: boolean
}

export const onlyNecessaryPreferences: CookieCategories = {
  analytics: false,
  marketing: false,
}

export const allPreferencesAccepted: CookieCategories = {
  analytics: true,
  marketing: true,
}

export const initialPreferences: CookieCategories = {
  analytics: DEFAULT_ANALYTICS_PREFERENCE,
  marketing: DEFAULT_MARKETING_PREFERENCE,
}

export const saveCookiePreferences = (prefs: CookieCategories) => {
  // TEMP: we always just send everything to segment, no matter what user chooses
  // TODO: cookies
  const tempPrefs = allPreferencesAccepted

  localStorage.setItem("cookiePreferences", JSON.stringify(tempPrefs))

  // TEMP: we don't clear up when category is removed
  // TODO: cookies
  // if (!prefs.analytics) {
  //   deleteGoogleAnalyticsCookies()
  // }

  // if (!prefs.marketing) {
  //   deleteFacebookPixelCookies()
  // }

  window.location.reload() // make analytics.load() fire up again with correct integrations
}

const getIntegrations = () => {
  const cookiePrefsString = localStorage.getItem("cookiePreferences")
  const cookiePreferences: CookieCategories | undefined =
    cookiePrefsString && JSON.parse(cookiePrefsString)

  // TEMP: always enable all integrations
  // TODO: cookies
  return {
    All: false,
    "Segment.io": true,
    Mixpanel: true,
    "Mixpanel (Actions)": true,
    "Actions Google Analytic 4": true,
    "Google Analytics 4 Web": true,
    "Facebook Pixel": true,
    "Google Tag Manager": true,
  }

  // return {
  //   All: false, // disable all others by default
  //   "Segment.io": true, // forward to segment
  //   Mixpanel: true, // always send to Mixpanel
  //   "Mixpanel (Actions)": true, // always send to Mixpanel
  //   "Actions Google Analytic 4": cookiePreferences
  //     ? cookiePreferences.analytics
  //     : DEFAULT_ANALYTICS_PREFERENCE,
  //   "Google Analytics 4 Web": cookiePreferences
  //     ? cookiePreferences.analytics
  //     : DEFAULT_ANALYTICS_PREFERENCE,
  //   "Facebook Pixel": cookiePreferences
  //     ? cookiePreferences.marketing
  //     : DEFAULT_MARKETING_PREFERENCE,
  //   "Google Tag Manager": cookiePreferences
  //     ? cookiePreferences.analytics
  //     : DEFAULT_ANALYTICS_PREFERENCE,
  // }
}

export const initializeAnalytics = () => {
  if (!window.analytics) {
    return
  }

  // for debugging purposes
  // window.analytics.debug(true)

  if (!window.analytics.initialized) {
    // fire up segment analytics integrations
    window.analytics.load(process.env.GATSBY_SEGMENT_WRITE_KEY, {
      integrations: getIntegrations(),
    })
  }
}

const deleteCookie = (cookieName: string) => {
  document.cookie =
    cookieName + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;"
}

const FACEBOOK_PIXEL_COOKIES = ["_fbp", "fr", "_fbc"]
const GOOGLE_ANALYTICS_COOKIES = ["_ga", "_gid", "_gat"]

const deleteGoogleAnalyticsCookies = () => {
  GOOGLE_ANALYTICS_COOKIES.forEach(deleteCookie)

  // aiming for _ga_<container-id>
  const cookies = document.cookie.split("; ")
  cookies.forEach((cookie) => {
    if (cookie.startsWith("_ga_")) {
      const cookieName = cookie.split("=")[0]
      deleteCookie(cookieName)
    }
  })
}

const deleteFacebookPixelCookies = () => {
  FACEBOOK_PIXEL_COOKIES.forEach(deleteCookie)
}
